if (!customElements.get('loovay-chat-position')) {
customElements.define('loovay-chat-position', class extends HTMLElement {
connectedCallback() {
this.controller = new AbortController();
this.frame = 0;
this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => this.update()); };
this.resize = new ResizeObserver(this.schedule);
this.resize.observe(document.documentElement);
this.observer = new MutationObserver(this.schedule);
this.observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class','style','hidden']});
for (const event of ['resize','scroll','transitionend']) window.addEventListener(event,this.schedule,{passive:true,signal:this.controller.signal});
this.update();
}
update() {
this.frame = 0;
const bar = document.getElementById('bundle-sticky_add_to_cart');
const rect = bar?.getBoundingClientRect();
const style = bar ? getComputedStyle(bar) : null;
const visible = rect && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity)>0 && rect.height>0 && rect.top<innerHeight && rect.bottom>0;
const value = Math.ceil(visible ? Math.max(0,innerHeight-rect.top) : 0)+'px';
if(document.documentElement.style.getPropertyValue('--loovay-chat-bar')!==value) document.documentElement.style.setProperty('--loovay-chat-bar',value);
if(bar!==this.bar) {
if(this.bar) this.resize.unobserve(this.bar);
this.bar=bar;
if(bar) this.resize.observe(bar);
}
}
disconnectedCallback() {
this.controller.abort(); this.observer.disconnect(); this.resize.disconnect(); cancelAnimationFrame(this.frame);
document.documentElement.style.removeProperty('--loovay-chat-bar');
}
});
}